import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import ContentBox from './ContentBox';

import FilterListIcon from '@mui/icons-material/FilterList';

import { Button } from '@mui/material';
import UserListSingle from './UserListSingle';

export default function UserList(props) {
    
  return (
    <TableContainer>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell sx={{width: '30%', paddingRight: 0}}><Typography variant="body1">Name</Typography></TableCell>
                    <TableCell sx={{width: '35%', paddingRight: 0}}><Typography variant="body1">Email</Typography></TableCell>
                    <TableCell sx={{width: '25%', paddingRight: 0}}><Typography variant="body1">Role</Typography></TableCell>
                    <TableCell sx={{width: '10%', paddingRight: 0}}>{props.filter && <Button onClick={props.filter} variant="text" endIcon={<FilterListIcon />}>Search</Button>}</TableCell>
                </TableRow>
            </TableHead>
        </Table>
        <ContentBox sx={{p: 0}}>
            <Table>
                <TableBody>
                    { ( props.data && ( props.data.length > 0 ) ) ?
                        props.data.map((row) => {
                            var userSingleProps = {
                                key: row.getId(),
                                data: row
                            };

                            if( props.onDelete )
                            {
                                userSingleProps['onDelete'] = props.onDelete;
                            }

                            if( props.onApprovedChange )
                            {
                                userSingleProps['onApprovedChange'] = props.onApprovedChange;
                            }

                            return (
                                <UserListSingle {...userSingleProps} />
                            )
                        }
                    )
                    :
                    <TableRow>
                        <TableCell colSpan={7} sx={{width: '100%', paddingRight: 0, textAlign: 'center'}} component="th" scope="row">
                            <Typography variant="body1">{props.noRecordsLabel || 'No results to display'}</Typography>
                        </TableCell>
                    </TableRow>
                    }
                </TableBody>
            </Table>
        </ContentBox>
    </TableContainer>
  );
}